import React from "react";
import Dan from "../images/dan-intro.png"
import css from "./NewIntro.css";

export const NewIntro = () => {
	return (
		<div className="intro-main">
			<section className="left-container">
                <div className="left-content">
				<h2 className="title">Hey! Dan here,</h2>
				<p className="information">
					Your local mobile bicycle mechanic. Serving Birmingham and surrounding
					areas since 2011. I offer a reliable, friendly door to door service -
					from puncture repair to full stripdowns.
				</p>
                </div>
			</section>
			<section className="right-container">
				<img className="Dan" src={Dan} alt="pic of Dan"></img>
				<div className="white-center"></div>
				<div className="yellow-background"></div>
			</section>
		</div>
	);
};
